import React from "react";

// Package Imports
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Tooltip } from "@mui/material";

const IconComponent = ({ status }: { status: string }) => {
  return status === "degraded" ? (
    <ReportProblemIcon className="pulse-mr-1" sx={{ color: "#fb7d1b" }} />
  ) : null;
};

const ActiveStateCell: React.FC<{
  status: string;
  status_message: string;
}> = React.memo(({ status, status_message }) => {
  return (
    <div
      className={`pulse-display-f pulse-align-center pulse-typography-body-1`}
    >
      {status_message ? (
        <Tooltip title={JSON.stringify(status_message)} arrow>
          <span>
            <IconComponent status={status} />
          </span>
        </Tooltip>
      ) : (
        <IconComponent status={status} />
      )}
    </div>
  );
});

export default ActiveStateCell;
